/**
 * Model definition for Product
 */
export interface IProduct {
  id: number;
  name: string;
  image?: any;
  price: number;
  discountedPrice?: number;
  available?: boolean;
  unit: IProductUnit;
  unitWeight?: number;
  description?: string;
  buyableAlone: boolean;
  directSale?: boolean;
}

export enum IProductUnit {
  kg = 'kg',
  pz = 'pz',
}
